module.exports = "/static/assets/878ad516d69f16d84a951159960d4ca5.png";